import { Component, Input, HostListener, ElementRef, EventEmitter, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import StringMask from 'string-mask';

import { Phone } from 'src/app/core/models/phone.model';
import { flagOptions } from 'src/app/core/constants/flag-Input-const';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-flag-input',
  templateUrl: './flag-input.component.html',
  styleUrls: ['./flag-input.component.scss']
})
export class FlagInputComponent implements OnInit, OnChanges {

  public flagOptions = flagOptions;
  @Input() label = '';
  @Input() isOpen = false;
  @Input() invalid = false;
  @Input() defaultCountry = '';
  @Input() phone: Phone = {phone: '', ddi: ''};
  @Output() changes: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  selectedOption;
  placeholder;
  fallbackFlag = 'Brasil';

  ngOnInit() {
    this.form = this.fb.group({
      phone: this.phone.phone ? this.phone.phone : '',
      ddi: this.phone.ddi ? this.phone.ddi : ''
    });
    if (this.phone.ddi) {
      this.selectedOption = this.flagOptions.find(flag =>  flag.prefix === this.phone.ddi);
    }
    if (this.defaultCountry) {
      this.selectedOption = this.flagOptions.find(flag =>  flag.country === this.defaultCountry);
    }
    if (!this.selectedOption) {
      this.selectedOption = this.flagOptions.find(flag => flag.country === this.fallbackFlag);
    }
    this.updateInput();
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.phone && changes.phone.firstChange) {
      return;
    }
    if (this.form.value.phone && !this.form.value.ddi) {
      return false;
    }
    this.form.patchValue(this.phone);
    this.selectedOption = this.flagOptions.find(flag =>  flag.prefix === this.form.value.ddi);
    this.updateInput();
  }

  @HostListener('window:click', ['$event'])
  onClick(ev) {
    if (this.isOpen) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpen = false;
      }
    }
  }

  constructor(private eRef: ElementRef, private fb: FormBuilder) { }

  updateInput() {
    this.placeholder = this.selectedOption.mask;
    this.changeFlag(this.selectedOption);
    this.changeMask();
  }

  changeFlag(flag) {
    this.selectedOption = flag;
    this.placeholder = flag.mask;
    this.form.controls.ddi.setValue(flag.prefix);
    this.emitPhone();
  }

  setFlag(flag) {
    this.isOpen = false;
    this.changeFlag(flag);
    this.form.controls.phone.setValue('');
  }

  changeMask() {
    const phone = this.form.value.phone.replace(/[^0-9]/g, '');
    switch (this.form.value.ddi) {
      case '+55': {
        this.form.controls.phone.setValue(this.brMask(phone));
        break;
      }
      case '+1': {
        this.form.controls.phone.setValue(this.usaMask(phone));
        break;
      }
      case '+351': {
        this.form.controls.phone.setValue(this.ptMask(phone));
        break;
      }

    }
    this.form.controls.phone.setValue(this.form.value.phone.replace(/[^0-9]+$/, ''));
    this.emitPhone();
  }

  brMask(phone) {
    if (phone.length < 11) {
      phone =  new StringMask(this.selectedOption.pattern[1]).apply(phone);
    } else {
      phone =  new StringMask(this.selectedOption.pattern[0]).apply(phone);
    }
    return phone;
  }

  usaMask(phone) {
    phone =  new StringMask(this.selectedOption.pattern[0]).apply(phone);
    return phone;
  }

  ptMask(phone) {
    phone =  new StringMask(this.selectedOption.pattern[0]).apply(phone);
    return phone;
  }


  emitPhone() {
    const phone = this.form.value;
    this.changes.emit(phone);
  }
}
